import { escapeRegExp } from "lodash-es";
import { z } from "zod";

export function replaceAllSpaces(string: string | undefined): string {
  return !string ? "" : string.replace(/\s/g, "");
}

export function hyphenLowercase(string: string | undefined): string {
  return !string ? "" : string.replace(/\s/g, "-").toLowerCase();
}

export function stringifyObjectValue(obj: object) {
  return Object.fromEntries(Object.entries(obj).map(([key, val]) => [key, val?.toString()]));
}

export function validateEmail(string: string): boolean {
  return z.email().safeParse(string).success;
}

export function trimLowercase(str: string | undefined): string {
  if (typeof str === "string") return str.split(" ").join("").toLocaleLowerCase();

  return "";
}

export function truncate(str = "", maxLength = 45) {
  if (str?.length > maxLength) {
    return `${str.slice(0, maxLength)}...`;
  }

  return str;
}

export function isValidHexColor(hexColor: string | null | undefined): boolean {
  if (!hexColor) {
    return false;
  }

  const hexRegex = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;
  return hexRegex.test(hexColor);
}

// Windchill-style name filter: `*` matches anything, matching ignores case, and a term with no `*`
// matches anywhere in the name (so "wing" and "*wing*" are the same filter).
export function toWildcardRegExp(pattern: string): RegExp {
  const glob = pattern.trim();
  const anchored = glob.includes("*") ? glob : `*${glob}*`;
  return new RegExp(`^${anchored.split("*").map(escapeRegExp).join(".*")}$`, "i");
}
